import Chip from "@mui/material/Chip";
import { CHIP_LABEL, chipToneClass, type ChipTone } from "./format";

export type SignalTone = "bull" | "bear" | "neutral";

type SignalBadgeProps = {
  label: string;
  tone: SignalTone;
};

const toChipTone = (t: SignalTone): ChipTone =>
  t === "bull" ? "success" : t === "bear" ? "error" : "neutral";

const dotClass = (t: SignalTone): string =>
  t === "bull" ? "bg-ta-green-main" : t === "bear" ? "bg-error-main" : "bg-token-text-secondary";

const SignalBadge = ({ label, tone }: SignalBadgeProps) => (
  <Chip
    size="small"
    className={`!rounded-full ${CHIP_LABEL} ${chipToneClass(toChipTone(tone))}`}
    label={(
      <span className="inline-flex items-center gap-1">
        <span className={`h-1.5 w-1.5 rounded-full ${dotClass(tone)}`} />
        {label}
      </span>
    )}
  />
);

export default SignalBadge;
